export default "__VITE_ASSET__BDwvFbVF__"